var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root lx-currency"},[_c('img',{staticClass:"img",class:{ circle: _vm.circle },attrs:{"src":_vm.image,"width":"20","height":"20"}}),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }